/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSortAZ = createReactComponent("sort-a-z", "IconSortAZ", [
  ["path", { d: "M16 8h4l-4 8h4", key: "svg-0" }],
  ["path", { d: "M4 16v-6a2 2 0 1 1 4 0v6", key: "svg-1" }],
  ["path", { d: "M4 13h4", key: "svg-2" }],
  ["path", { d: "M11 12h2", key: "svg-3" }]
]);

export { IconSortAZ as default };
//# sourceMappingURL=IconSortAZ.js.map
